import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import css from './DragAndDrop.module.scss';

export const dragAndDropItemClass = 'drag-and-drop-item';

export interface DragAndDropItemProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  testId?: string;
  hasDragHandle?: boolean;
}

export const DragAndDropItem: React.FC<DragAndDropItemProps> = ({
  children,
  className,
  style,
  testId = 'drag-and-drop-item',
  hasDragHandle,
}) => (
  <div
    data-component="DragAndDropItem"
    className={classNames(dragAndDropItemClass, css.item, className)}
    style={style}
    data-testid={testId}
    draggable
    data-has-drag-handle={!!hasDragHandle}
  >
    {children}
  </div>
);

DragAndDropItem.displayName = 'DragAndDropItem';
